/*
 * XING SUN — Confete ao atingir uma etapa da barra de progresso do carrinho.
 * Dispara APENAS quando o cliente CRUZA (atinge) o marco 1 (LEVE 3) ou o marco 2 (LEVE 6).
 * Nunca dispara no carregamento da pagina nem no marco inicial (INICIO).
 * Efeito leve, sem dependencias externas (Web Animations API).
 */
(function () {
  if (window.__cpbConfettiInit) return;
  window.__cpbConfettiInit = true;

  var COLORS = ['#8b2fe0', '#a855f7', '#c084fc', '#7c22ce', '#ffffff', '#ffd54a'];
  var PIECES = 150;

  function fireConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // posiciona o palco sobre a gaveta do carrinho (ou viewport como fallback)
    var host = document.querySelector('cart-drawer .drawer__inner')
      || document.querySelector('cart-drawer')
      || document.body;
    var r = host.getBoundingClientRect();
    var top = Math.max(r.top, 0);
    var height = (r.height && r.height > 0) ? r.height : window.innerHeight;

    var stage = document.createElement('div');
    stage.className = 'cpb-confetti';
    stage.setAttribute('aria-hidden', 'true');
    stage.style.left = r.left + 'px';
    stage.style.top = top + 'px';
    stage.style.width = (r.width || window.innerWidth) + 'px';
    stage.style.height = height + 'px';
    document.body.appendChild(stage);

    for (var i = 0; i < PIECES; i++) {
      var piece = document.createElement('span');
      piece.className = 'cpb-confetti__piece';
      var size = 5 + Math.random() * 8;                 // 5..13px
      piece.style.left = (Math.random() * 100) + '%';   // posicao horizontal aleatoria
      piece.style.top = (-12 - Math.random() * 60) + 'px'; // comeca acima, alturas variadas
      piece.style.width = size + 'px';
      piece.style.height = (size * (0.45 + Math.random() * 0.55)) + 'px';
      piece.style.background = COLORS[(Math.random() * COLORS.length) | 0];
      if (Math.random() < 0.4) piece.style.borderRadius = '50%'; // mistura circulos e retangulos
      stage.appendChild(piece);

      var dx = (Math.random() * 220) - 110;             // deriva horizontal -110..110
      var rot = Math.random() * 360;
      var spin = 360 + Math.random() * 540;             // giro total
      var dur = 2600 + Math.random() * 1700;            // 2.6..4.3s (lento)
      var delay = Math.random() * 950;                  // chuva continua 0..0.95s

      piece.animate(
        [
          { transform: 'translate(0, 0) rotate(' + rot + 'deg)', opacity: 1 },
          { transform: 'translate(' + (dx * 0.6) + 'px, ' + (height * 0.85) + 'px) rotate(' + (rot + spin * 0.8) + 'deg)', opacity: 1, offset: 0.8 },
          { transform: 'translate(' + dx + 'px, ' + (height + 50) + 'px) rotate(' + (rot + spin) + 'deg)', opacity: 0 }
        ],
        { duration: dur, delay: delay, easing: 'cubic-bezier(.2,.65,.4,1)', fill: 'forwards' }
      );
    }

    setTimeout(function () {
      if (stage && stage.parentNode) stage.parentNode.removeChild(stage);
    }, 5600);
  }
  window.cpbFireConfetti = fireConfetti;

  var prev = null; // baseline; null = ainda nao medido

  function check() {
    var bar = document.querySelector('[data-cpb-count]');
    if (!bar) return;
    var count = parseInt(bar.getAttribute('data-cpb-count') || '0', 10);
    var m1 = parseInt(bar.getAttribute('data-cpb-meta1') || '0', 10);
    var m2 = parseInt(bar.getAttribute('data-cpb-meta2') || '0', 10);
    var dual = bar.getAttribute('data-cpb-dual') === '1';

    // lista de todos os degraus (5,10,15,20,30). Fallback pros metas antigos.
    var tiersAttr = bar.getAttribute('data-cpb-tiers');
    var tiers = [];
    if (tiersAttr) {
      tiers = tiersAttr.split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; });
    }

    if (prev === null) { prev = count; return; } // 1a leitura = baseline, nao dispara

    if (count > prev) {
      var crossed = false;
      if (tiers.length) {
        // dispara ao cruzar QUALQUER degrau (a partir do 1o desconto)
        for (var i = 0; i < tiers.length; i++) {
          if (prev < tiers[i] && count >= tiers[i]) { crossed = true; break; }
        }
      } else {
        var reachedM1 = (m1 > 0 && prev < m1 && count >= m1);
        var reachedM2 = (dual && m2 > 0 && m2 !== m1 && prev < m2 && count >= m2);
        crossed = reachedM1 || reachedM2;
      }
      if (crossed) fireConfetti();
    }
    prev = count;
  }

  var t;
  var obs = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(check, 120);
  });

  function start() {
    var scope = document.querySelector('cart-drawer') || document.body;
    obs.observe(scope, { childList: true, subtree: true });
    check(); // estabelece o baseline com o carrinho atual
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
